<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('report_income_statement')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onPrint"><i class="fa fa-print"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-5">
                            <h3 class="text-center">INCOME STATEMENT</h3>
                            <table class="table-x">
                                <tbody>
                                    <tr>
                                        <td>Sales</td>
                                        <td class="text-right">{{$money(statement.SaleAmount)}}</td>
                                    </tr>
                                    <tr style="border-bottom: 1px solid #ccc;">
                                        <td>Cost of Goods Sold (COGS)</td>
                                        <td class="text-right">{{$money(statement.CostAmount)}}</td>
                                    </tr>
                                    <tr>
                                        <th>Gross Profit</th>
                                        <th class="text-right">{{$money(statement.GrossProfit)}}</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2">Operating Expense</th>
                                    </tr>
                                    <tr v-for="(ret,index) in statement.OperationExpenses" :key="index">
                                        <td>{{index}}</td>
                                        <td class="text-right">{{$money(ret)}}</td>
                                    </tr>
                                    <tr style="border-top: 1px solid #ccc;">
                                        <th>Total Expense</th>
                                        <th class="text-right">{{$money(statement.TotalExpense)}}</th>
                                    </tr>
                                    <tr>
                                        <td colspan="2">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th>Net Income</th>
                                        <th class="text-right">{{$money(statement.NetProfit)}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                statement: {}
            }
        },
        created(){
            this.toList();
        },
        methods: {
            toList(){
                let loading = this.$loading.show();
                this.$api().post('report/income-statement', { }).then(res => {
                    if(this.$isValid(res)){
                        this.statement = res.data.Json.IncomeStatement;
                    }
                }).finally(() => { loading.hide(); });
            },
            onPrint(){

            }
        }
    }
</script>
<style scoped>
    .table-x{
        width: 100%;
    }
    .table-x tbody>tr>td,
    .table-x tbody>tr>th{
        padding: 5px 0;
    }
</style>